<div class="container">
  <div class="filter-tags">
    @for (tag of tags(); track tag.title) {
      <coin-c-list-view-filter-tag
        [tag]="tag"
        [selections]="filterParameter$() | async"
        (addFilter)="addFilter($event)"
        (removeFilter)="removeFilter($event)"></coin-c-list-view-filter-tag>
    }
    @if ((filterParameter$() | async)?.length) {
      <coin-v2-button
        type="outline"
        icon="chevron_right"
        iconPos="right"
        [text]="'general.reset' | translate"
        (click)="resetFilters()"></coin-v2-button>
    }
  </div>
</div>
